import { render, staticRenderFns } from "./MajorResult.vue?vue&type=template&id=6d8a93e0"
import script from "./MajorResult.vue?vue&type=script&lang=js"
export * from "./MajorResult.vue?vue&type=script&lang=js"
import style0 from "./MajorResult.vue?vue&type=style&index=0&id=6d8a93e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MajorTable: require('/app/nuxt/components/MajorTable.vue').default,Section: require('/app/nuxt/components/Section.vue').default})
